<template>
  <div>
    <div style="margin: 10px 0">
      <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 300px;"></el-input>
      <el-dropdown split-button type="primary" @command="commandEvent">
        <span v-html="dropdownTitle"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="全部">全部</el-dropdown-item>
          <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="isAjax" plain>查询</el-button>
    </div>
    <el-alert
      type="info">
      <span>注意：数据默认每隔10分钟更新一次 或 可以进行手动更新数据：</span>
      <el-button type="mini" @click="sdUpdateData" plain>手动更新数据</el-button>
    </el-alert>
    <el-collapse v-model="activeNames" class="aside" :style="divHeight">
      <el-collapse-item v-for="item in dataKanbanList" :key="item._id" :title="item.customerName" :name="item.customerName">
        <el-badge :value="(item.orderNoPushNum?item.orderNoPushNum:'0')" class="item" type="warning" style="margin: 10px;">
          <div style="text-align: center;">
            <i class="el-icon-s-order" style="font-size: 34px;"></i><br/><span style="font-size: 14px;">未推送订单</span>
          </div>
        </el-badge>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  export default {
    name: 'dataKanban',
    data(){
      return {
        activeNames: [],
        dataKanbanList:[],
        dropdownTitle:"请选择",
        serchat:"",
        divHeight:{
          "height":"500px"
        },
        dropdownList:[]
      }
    },
    methods:{
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      sdUpdateData:async function(){
        await this.$axios.post('/data/updateKanbanData',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.isAjax()
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      isAjax:async function(){
        await this.$axios.post('/data/addOrderNoPushNum',{
          d:this.dropdownTitle,
          s:this.serchat,
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dataKanbanList = response.data;
            for(var i=0;i<response.data.length;i++){
              var _n = response.data[i].orderNoPushNum?response.data[i].orderNoPushNum:0;
              if(_n>0){
                this.activeNames.push(response.data[i].customerName)
              }
            }
            this.divHeight.height = window.innerHeight-158+"px";
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      }
    },
    mounted(){
      this.addClass();
      this.isAjax();
      var _this = this;
      setInterval(function () {
        _this.isAjax();
      },60000);
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .aside{
    overflow-x: hidden;overflow-y: auto;
  }
  .aside::-webkit-scrollbar {/*滚动条整体样式*/
    width: 7px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .aside::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #535353;

  }
  .aside::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 7px;
    background: #EDEDED;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/dataKanban.vue